import React, { useEffect } from "react"
import styles from "./index.module.scss"
import { LiveProvider, LiveEditor } from "react-live"
import theme from "../../theme"
import CopyIcon from "./Copy.svg"

const parseInputFromString = str => {
  return new DOMParser().parseFromString(str, "text/html").body.children[0]
}

const stringifyInput = input => {
  return input.outerHTML
    .split(" ")
    .join("\n  ")
    .replace(/>$/, "  \n/>")
}

function usePrevious(value) {
  const ref = React.useRef()
  React.useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}

const Code = ({ html, type, autocomplete, inputmode, setConfig }) => {
  const [codeContents, setCodeContents] = React.useState(html)

  const [error, setError] = React.useState(false)

  const [showCopySuccess, setShowCopySuccess] = React.useState(false)

  // respond to programmatic change on right panel
  useEffect(() => {
    try {
      const input = parseInputFromString(codeContents)
      setError(false)

      let hasChange = false
      const simpleAttrs = [
        ["type", type],
        ["inputmode", inputmode],
        ["autocomplete", autocomplete],
      ]
      simpleAttrs.forEach(([str, html]) => {
        if (input.getAttribute(str) !== html) {
          hasChange = true
          if (html) return input.setAttribute(str, html)
          return input.removeAttribute(str)
        }
      })

      if (hasChange) {
        const newHTMLText = stringifyInput(input)
        setCodeContents(newHTMLText)
      }
    } catch (e) {
      setError(true)
      return
    }
  }, [type, autocomplete, inputmode]) // eslint-disable-line

  const previousCodeContents = usePrevious(codeContents)
  // respond to user editing code editor on the left
  useEffect(() => {
    // dont set state on initial render!
    if (!previousCodeContents) return
    try {
      const input = parseInputFromString(codeContents)
      setError(false)
      const type = input.getAttribute("type")
      const autocomplete = input.getAttribute("autocomplete")
      const inputmode = input.getAttribute("inputmode")
      setConfig({
        type,
        autocomplete,
        inputmode,
      })
    } catch (e) {
      console.log(e)
      setError(true)
    }
  }, [codeContents]) // eslint-disable-line

  const formattedCodeContents = codeContents.trim()
  return (
    <div>
      <div className={styles.editorContainer}>
        <button
          className={styles.copy}
          onClick={() => {
            navigator.clipboard.writeText(html)
            setShowCopySuccess(true)
            setTimeout(() => {
              setShowCopySuccess(false)
            }, 4000)
          }}
        >
          <CopyIcon />
          {showCopySuccess ? "copied!" : "copy"}
        </button>
        <LiveProvider code={formattedCodeContents} theme={theme}>
          <LiveEditor
            className={styles.editor}
            onChange={htmlString => {
              setCodeContents(htmlString)
            }}
          />
        </LiveProvider>
        <div className={styles.editPrompt}>edit me</div>
      </div>
      <div>
        {error && (
          <div className={styles.error}>
            <b style={{ color: "rgb(255, 88, 116)" }}> Oh no!</b> I can't parse
            this code
          </div>
        )}
      </div>
    </div>
  )
}

export default Code
